import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";

export const GROUP_TEMPORARY_USER_RESOURCE = "group" as const;
export const GROUP_TEMPORARY_USER_OPERATION = "temporary-user" as const;
export const GROUP_TEMPORARY_USER_API_PATH =
  `/v1/${GROUP_TEMPORARY_USER_RESOURCE}/{uuid}/${GROUP_TEMPORARY_USER_OPERATION}` as const;

export type GroupTemporaryUserResponse =
  paths[typeof GROUP_TEMPORARY_USER_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export const useGroupTemporaryUserQuery = (uuid: string) =>
  useQuery({
    enabled: !!uuid,
    queryKey: [GROUP_TEMPORARY_USER_RESOURCE, uuid, GROUP_TEMPORARY_USER_OPERATION],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<GroupTemporaryUserResponse>(
        `/v1/${GROUP_TEMPORARY_USER_RESOURCE}/${uuid}/${GROUP_TEMPORARY_USER_OPERATION}`,
      );

      return response.data;
    },
  });
